export default __webpack_public_path__ + "static/media/back-arrow-white.0fe0d0d7.svg";